import {Component, OnInit} from '@angular/core';
import {ModalController, NavParams, Platform} from "@ionic/angular";
import {PreloaderService} from "../../../../services/preloader/preloader.service";
import {ParentService} from "../../../../services/mygreencountry/parent.service";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {

    isAndroid: boolean = false;
    androidLink: string;
    webLink: string;
    isApp: boolean = false;
    showInfoBlock:boolean = false;

    constructor(private modalCtrl: ModalController,
                private platform: Platform,
                public myGcService: MyGreenCountry,
                private navParams: NavParams,
    ) {
    }


    ngOnInit() {
        this.androidLink = this.navParams.data['androidLink'];
        this.webLink = this.navParams.data['webLink'];
        this.isApp = this.platform.is('hybrid');
    }

    byCardOnline() {

        if (this.isApp){
            this.openWebLink();
        }else{

            this.showInfoBlock=true;
        }


    }

    openWebLink(){
        if (this.webLink) {
            this.close().then(r => {
                this.myGcService.openUrl(this.webLink)
            })

        }
    }


    anotherWay() {
        if (this.androidLink) {
            this.close().then(r => {
                this.myGcService.openUrl(this.androidLink)
            })

        }
    }

    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

    showPopover(event: Event) {
        event.stopPropagation();

        let target = event.target as HTMLElement;
        let pricePopover = target.querySelector('.price-popover');

        if (pricePopover) {
            pricePopover.classList.toggle('d-none');
        }
    }
}
